import { Select, SelectContent } from "@dextech-ai/dex-design-system";
import {
	applySelectedValues,
	getSelectedValues,
	renderSelectItems,
} from "@/utils/select-items";
import PropTypes from "prop-types";
import React from "react";

const MultiSelectFilter = ({
	dataTestId,
	filter,
	options,
	preFilter,
	setPreFilter,
}) => {
	return (
		<div className="data_table__filterrow" key={filter.key}>
			<span className="filter_row__title">{filter.label}</span>

			<div className="filter_row__option">
				<Select
					multiple
					placeholder="Select"
					maxTagCount="responsive"
					data-testid={`${dataTestId}-multiSelect`}
					notFoundContent="This is empty"
					value={getSelectedValues(options)}
					onChange={(values) => {
						setPreFilter({
							...preFilter,
							[filter.key]: applySelectedValues(
								options,
								values
							).filter((s) => s.$selected),
						});
					}}
				>
					<SelectContent>{renderSelectItems(options)}</SelectContent>
				</Select>
			</div>
		</div>
	);
};

MultiSelectFilter.propTypes = {
	dataTestId: PropTypes.string,
	filter: PropTypes.object.isRequired,
	options: PropTypes.array,
	preFilter: PropTypes.object.isRequired,
	setPreFilter: PropTypes.func.isRequired,
};

export default MultiSelectFilter;
